import styles from './index.module.scss'
import { Dropdown, Input, Space, Select, message } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useState, useContext, useEffect } from 'react'
import SelectBtnGroups from '@view/page_v3/components/SelectBtnGroups';
import { ProjectContext } from '../../../hooks/ProjectContext'
import Iconfont from '@utils/Iconfont';
import { AppContext } from '@utils/AppContext';
import { IMAGE_TYPE } from '@utils/CONST'
import API from '@api/api.js';

const SORTMAP = {
    'updatedTime': "修改时间",
    'projectName': "项目名称",
}

const TYPEMAP = {
    "model": "换模特/背景图",
    "simTryon": "同版型试衣",
    "poseFantasy": "姿势裂变",
    "clothes": "AI试衣图",
    "shoesTryon": "鞋子上脚图",
    "tryonVideo": "模特视频",
    "commodity": "AI商品图",
    "commodityRecolor": "商品换色图",
    "glassesTryon": "眼镜试戴图",
}

const ProListpageTop = (props) => {
    const {
        proOrder, setProOrder,
        proSortField, setProSortField,
        proFunction, setProFunction,
        projectName, setProjectName
    } = useContext(ProjectContext)
    const { proSidebarValue, globalOrgInfo } = useContext(AppContext);
    const [memberList, setMemberList] = useState([]);
    const items = [
        {
            key: 'updatedTime',
            label: <p>修改时间</p>,
            onClick: () => { setProSortField('updatedTime'); localStorage.setItem('sortField', 'updatedTime') }
        }, {
            key: 'projectName',
            label: <p>项目名称</p>,
            onClick: () => { setProSortField('projectName'); localStorage.setItem('sortField', 'projectName') }
        }
        , {
            type: 'divider',
        }
        , {
            key: 'asc',
            label: <p>升序</p>,
            onClick: () => { setProOrder('asc'); localStorage.setItem('order', 'asc') }
        }, {
            key: 'desc',
            label: <p>降序</p>,
            onClick: () => { setProOrder('desc'); localStorage.setItem('order', 'desc') }
        },
    ];

    const projectType = {
        "model": [{
            key: 'all',
            label: <p>全部展示</p>,
            onClick: () => { setProFunction('') }
        }, {
            key: 'model',
            label: <p>换模特/背景图</p>,
            onClick: () => { setProFunction('model') }
        }, {
            key: 'clothes',
            label: <p>AI试衣图</p>,
            onClick: () => { setProFunction('clothes') }
        }, {
            key: 'simTryon',
            label: <p>同版型试衣</p>,
            onClick: () => { setProFunction('simTryon') }
        }, {
            key: 'poseFantasy',
            label: <p>姿势裂变</p>,
            onClick: () => { setProFunction('poseFantasy') }
        }, {
            key: 'shoesTryon',
            label: <p>鞋子上脚图</p>,
            onClick: () => { setProFunction('shoesTryon') }
        }, {
            key: 'glassesTryon',
            label: <p>眼镜试戴图</p>,
            onClick: () => { setProFunction('glassesTryon') }
        }, {
            key: 'tryonVideo',
            label: <p>模特视频</p>,
            onClick: () => { setProFunction('tryonVideo') }
        }],
        "commodity": [{
            key: 'all',
            label: <p>全部展示</p>,
            onClick: () => { setProFunction('') }
        }, {
            key: 'commodity',
            label: <p>AI商品图</p>,
            onClick: () => { setProFunction('commodity') }
        }, {
            key: 'commodityRecolor',
            label: <p>商品换色图</p>,
            onClick: () => { setProFunction('commodityRecolor') }
        }],
        "aiEdit": [{
            key: 'all',
            label: <p>全部展示</p>,
            onClick: () => { setProFunction('') }
        }],
    }

    const getListOrgMember = () => {
        API.getListOrgMember({}).then((res) => {
            if (res.code !== 0) return message.error(res.msg);
            const list = res.data.filter(item => item.role != 'admin').map(item => ({
                value: item.userId,
                label: item.deleted? item.orgNickname + '（已移除）': item.orgNickname,
            }));
            setMemberList(list);
        });
    }
    const memberChange = value => {
        props.setMember(value || 'team')
    };

    useEffect(() => {
        getListOrgMember()
    }, [])

    return (
        <div className={styles.ProListpageTop}>
            <div>
                <Dropdown menu={{ items }} trigger={['click']}>
                    <Space style={{ marginRight: '24px' }}>
                        {SORTMAP[localStorage.getItem('sortField') || proSortField]}
                        <DownOutlined className={styles.dropdown_action} />
                    </Space>
                </Dropdown>
                {
                    proSidebarValue != IMAGE_TYPE.AIEDIT && <Dropdown menu={{ items: projectType[proSidebarValue] }} trigger={['click']}>
                        <Space style={{ marginRight: '24px' }}>
                            {TYPEMAP[proFunction] || '全部展示'}
                            <DownOutlined className={styles.dropdown_action} />
                        </Space>
                    </Dropdown>
                }
                {
                    (globalOrgInfo?.current?.role == 'admin' && props.tabKey == '2') && <Select
                        style={{ width: 200, marginRight: '8px'}}
                        allowClear
                        member={props.member}
                        onChange={memberChange}
                        placeholder="请选择成员"
                        options={memberList}
                    />
                }

                <Input
                    allowClear
                    value={projectName}
                    className={styles.focused}
                    placeholder="请搜索的项目名称"
                    suffix={<Iconfont type="icon-SearchOutlined" style={{ fontSize: 16, color: '#5b6673' }} />}
                    onChange={(e) => setProjectName(e.target.value)}
                />
            </div>
            <SelectBtnGroups
                getIsSelected={props.getIsSelected}
                setSelectedList={props.setSelectedList}
                selectedList={props.selectedList}
                isSelectedAll={props.isSelectedAll}
                downLoading={props.downLoading}
                selectAll={props.selectAll}
                deleteClick={props.deleteClick}
                downClick={props.downClick}
            />
        </div>
    )
}

export default ProListpageTop
